module.exports = (__parcel__import__("./" + "Debugger.worker.77753fbf.0a5236a4.js")).then(() => parcelRequire('hbCbi'));